import { createSlice } from "@reduxjs/toolkit";

const initialdashboardState = {
  listLoading: false,
  actionsLoading: false,
  inactiveOrg: [],
  totalCountInactiveOrg: 0,
  productiveOrg: [],
  totalCountProductiveOrg: 0,
  dashboardForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminDashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialdashboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getdashboardById
    dashboardFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.dashboardForEdit = action.payload.dashboardForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // finddashboard
    inactiveOrgFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.inactiveOrg = items;
      state.totalCountInactiveOrg = total_items;
    },
    productiveOrgFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.productiveOrg = items;
      state.totalCountProductiveOrg = total_items;
    },
    // Set to default state actionLoading & error
    dashboardReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    dashboardFiles: (state, action) => {
      state.dashboardFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
